export default {
  //API
  apiBaseHost: 'https://api.farmakom.io',
  apiBasePath: '/v1/frontend',
  devApiBaseHost: 'http://localhost:8081',

  // CDN
  cdnBaseHost: 'https://cdn.farmakom.io',

  // SSR
  useSSR: true,

  // DEV - for prod leave everything commented

  // hostname: 'metafarm.info',
  // hostname: 'farmafamily.it',
  // hostname: 'test.farmakom.it',
  // hostname: 'farmacia33.it',
  // useDevApi: true,
};
